import { css } from '@emotion/react'
import { HFlow, Text, VFlow } from 'bold-ui'
import { useMemo } from 'react'

import { Chamada } from '../model-chamadaPainel'
import { TagTipoAtendimentoPainelChamada } from './TagTipoAtendimentoPainelChamada'

interface PainelChamadaDestaqueProps {
  chamadaAtual: Chamada | null
  isChamando: boolean
}

export function PainelChamadaDestaque(props: Readonly<PainelChamadaDestaqueProps>) {
  const { chamadaAtual, isChamando } = props

  const nomeFormatado = useMemo(() => chamadaAtual?.nome.abbreviateMiddleNames(), [chamadaAtual])
  const styles = useMemo(() => createStyles(!!chamadaAtual), [chamadaAtual])

  const renderContent = () => {
    if (!chamadaAtual) {
      return (
        <VFlow vSpacing={0}>
          <Text color='inherit' fontWeight='bold' style={styles.waitingTitleText}>
            Por favor, aguarde.
          </Text>
          <Text color='inherit' fontWeight='bold' fontSize={3}>
            Sua chamada aparecerá neste painel.
          </Text>
        </VFlow>
      )
    }

    if (isChamando) {
      return (
        <VFlow vSpacing={2.25}>
          <Text color='inherit' fontWeight='bold' style={styles.roomText}>
            {chamadaAtual.sala}
          </Text>
          <TagTipoAtendimentoPainelChamada tipoAtendimento={chamadaAtual.tipoAtendimento} />
          <Text color='inherit' fontWeight='bold' style={styles.nameText}>
            {nomeFormatado}
          </Text>
        </VFlow>
      )
    }

    return (
      <VFlow vSpacing={3}>
        <HFlow justifyContent='space-between'>
          <TagTipoAtendimentoPainelChamada tipoAtendimento={chamadaAtual.tipoAtendimento} />
          <Text color='inherit' fontWeight='bold' style={styles.roomText}>
            {chamadaAtual.sala}
          </Text>
        </HFlow>
        <Text color='inherit' fontWeight='bold' style={styles.nameText}>
          {nomeFormatado}
        </Text>
      </VFlow>
    )
  }

  return (
    <VFlow style={styles.mainContent} vSpacing={0}>
      {renderContent()}
    </VFlow>
  )
}

const createStyles = (hasChamada: boolean) => ({
  mainContent: css`
    flex-grow: 1;
    justify-content: ${hasChamada ? 'center' : 'flex-end'};
  `,
  nameText: css`
    font-size: 5rem;
    line-height: 1.2;
  `,
  waitingTitleText: css`
    font-size: 5rem;
    line-height: 1.2;
  `,
  roomText: css`
    font-size: 4rem;
    line-height: 1;
  `,
})
